import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { GetLandinSections } from './landing.actions';
import { LandingState } from './landing.state';

@Injectable({
    providedIn: 'root'
})
export class LandingFacade {
    public sections$ = this.store.select(LandingState.sections);
    constructor(private store: Store) {}

    getAll() {
        return this.store.dispatch(new GetLandinSections());
    }
}
